import { createContext, useContext } from "react";

export class AuthService {

    private token: string | null = null;

    constructor() {
        this.token = localStorage.getItem('token') || window.sessionStorage.getItem('token') || null;
    }

    setAuthToken(token: string, persistToken: boolean) {

        // Clear the current token
        this.clearAuthToken();

        // Set the new token
        if (persistToken) {
            localStorage.setItem('token', token);
        } else {
            window.sessionStorage.setItem('token', token);
        }

        this.token = token;
    }

    clearAuthToken() {
        localStorage.removeItem('token');
        window.sessionStorage.removeItem('token');
        this.token = null;
    }

    getAuthToken() {
        return this.token;
    }

    isAuthenticated() {
        return this.getAuthToken() !== null;
    }

    isTokenExpired() {
        return this.getAuthToken() !== null;
    }
}

const authService = new AuthService();
const AuthServiceContext = createContext<AuthService>(authService);

export function AuthServiceProvider({ children }: { children: React.ReactNode }) {
    return (
        <AuthServiceContext.Provider value={authService} >
            {children}
        </AuthServiceContext.Provider>
    );
}

export function useAuthService() {
    return useContext(AuthServiceContext);
}